/* GrokBot 2026-10-17: shared VG tilt v1 — one elegant pointer tilt for all product-page cards.
   Opt-in: add data-vg-tilt (or class .vg-tilt) to any element; SEL below auto-tags known VG widgets.
   Fine pointers only (desktop hover). No gyroscope, no touch effect. Off with prefers-reduced-motion. */
(function(){
  if(window.__vgTilt)return;window.__vgTilt=1;
  var P={max:1,edge:20,persp:1400,ease:.06,sheen:.22}; /* 2026-10-17 20:58 per T: max ~1deg, slow easing */
  var SEL=['.vgwp__card','.vg-spec','.vgcr2','.vgcase','.vgk--b3','.vg-serve','.vgso-card','.vg-ptrust','.vg-trust-strip','.vgpk','.vgm','.vgx-reviews','.vg-rr-prompt','.vg-rr__card','.vg-related .vgrl','[data-vg-tilt]','.vg-tilt'];
  var mq=window.matchMedia?matchMedia('(prefers-reduced-motion: reduce)'):{matches:false};
  var fine=window.matchMedia&&matchMedia('(hover:hover) and (pointer:fine)');
  function ok(){return fine&&fine.matches&&!mq.matches}
  function bind(el){
    if(el.__vgt)return;el.__vgt=1;el.setAttribute('data-vg-tilt','');
    if(getComputedStyle(el).position==='static')el.classList.add('vgt-rel');
    var sh=document.createElement('span');sh.className='vgt-sheen';sh.setAttribute('aria-hidden','true');el.appendChild(sh);
    var tx=0,ty=0,cx=0,cy=0,mx=50,my=50,raf=0,on=false,mxDeg=P.max;
    function loop(){
      cx+=(tx-cx)*P.ease;cy+=(ty-cy)*P.ease;
      el.style.setProperty('--vgt-rx',(cy*mxDeg).toFixed(3)+'deg');
      el.style.setProperty('--vgt-ry',(cx*mxDeg).toFixed(3)+'deg');
      el.style.setProperty('--vgt-mx',mx.toFixed(1)+'%');el.style.setProperty('--vgt-my',my.toFixed(1)+'%');
      el.style.setProperty('--vgt-sx',(-cx*10).toFixed(1)+'px');el.style.setProperty('--vgt-sy',(10-cy*6).toFixed(1)+'px');
      if(on||Math.abs(cx)>.002||Math.abs(cy)>.002){raf=requestAnimationFrame(loop)}
      else{raf=0;el.classList.remove('is-vgt');['--vgt-rx','--vgt-ry','--vgt-sx','--vgt-sy'].forEach(function(k){el.style.removeProperty(k)})}
    }
    function kick(){if(!raf)raf=requestAnimationFrame(loop)}
    el.addEventListener('pointerenter',function(e){if(e.pointerType!=='mouse'||!ok())return;var w=el.offsetWidth||1;
      mxDeg=Math.min(P.max,Math.atan(P.edge/(w/2))*180/Math.PI);on=true;el.classList.add('is-vgt','is-vgt-on');kick()});
    el.addEventListener('pointermove',function(e){if(!on)return;var b=el.getBoundingClientRect(),px=(e.clientX-b.left)/b.width,py=(e.clientY-b.top)/b.height;
      px=Math.max(0,Math.min(1,px));py=Math.max(0,Math.min(1,py));tx=(px-.5)*2;ty=(.5-py)*2;mx=px*100;my=py*100;kick()},{passive:true});
    el.addEventListener('pointerleave',function(){if(!on)return;on=false;tx=0;ty=0;el.classList.remove('is-vgt-on');kick()});
  }
  function scan(root){(root||document).querySelectorAll(SEL.join(',')).forEach(function(el){
    if(el.parentElement&&el.parentElement.closest('[data-vg-tilt]'))return; /* no nested tilts */
    bind(el)})}
  function init(){if(!ok())return;scan();
    if('MutationObserver' in window){var t=0;new MutationObserver(function(){clearTimeout(t);t=setTimeout(scan,250)}).observe(document.body,{childList:true,subtree:true})}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  window.vgTilt={bind:bind,scan:scan,params:P};
})();
